import React, { memo, useState } from 'react'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import PropTypes from 'prop-types'
import { Card } from 'transfix-ui/components/Card'
import { Spinner } from 'transfix-ui/components/Spinner'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { ALL } from 'constants/notes'
import { notePropType } from './components/Note'
import { NoteInput } from './components/NoteInput'
import { NotesList } from './components/NotesList'
import 'scss/5_components/_notes-new.scss'

export const NotesCard = memo(
  ({
    error,
    fetching,
    getNotes,
    initialFilter,
    noteableId,
    noteableType,
    notes,
    submitCallback,
    submitNote,
    to: { id: toId },
  }) => {
    const [filter, setFilter] = useState(initialFilter || ALL.value)
    const { userDetails } = useUserDetails()
    const ready = !fetching && !error
    const firstLoad = fetching && !notes.length
    const onSubmitNote = ({ body, callbackDate, callbackTime, showCallback }) => {
      submitNote(
        {
          body,
          createdById: userDetails?.id,
          noteableType: toId ? 'User' : noteableType,
          noteableId: toId || noteableId,
          getNotesParams: {
            noteableId,
            noteableType,
          },
          ...(showCallback
            ? {
                callbackDate,
                callbackTime,
              }
            : {}),
        },
        filter
      )
    }

    return (
      <Card title='Notes'>
        <NoteInput onSubmitNote={onSubmitNote} sending={fetching} error={error} />
        {error && <FeedbackMessage message={error} type='error' />}
        {firstLoad && <Spinner />}
        <NotesList
          filter={filter}
          setFilter={setFilter}
          notes={notes}
          noteableId={noteableId}
          noteableType={noteableType}
          ready={ready}
          submitCallback={submitCallback}
          getNotes={getNotes}
        />
      </Card>
    )
  }
)

NotesCard.propTypes = {
  getNotes: PropTypes.func,
  submitCallback: PropTypes.func,
  submitNote: PropTypes.func,
  noteableType: PropTypes.string,
  noteableId: PropTypes.number,
  to: PropTypes.shape({
    id: PropTypes.number,
  }),
  notes: PropTypes.arrayOf(notePropType),
  fetching: PropTypes.bool,
  error: PropTypes.string,
}

NotesCard.defaultProps = {
  getNotes: () => {},
  submitCallback: () => {},
  submitNote: () => {},
  noteableType: null,
  noteableId: null,
  to: {},
  notes: [],
  fetching: false,
  error: null,
}

export default NotesCard
